import { makeAutoObservable } from 'mobx';
import { sanitizeHtml } from '~/serverUtils/sanitizeHtml';

export default class FreetextStore {
    isFetchingFreetexts: boolean = false;
    freetext: {
        [key: string]: {
            value: string;
        };
    } = {};

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.freetext = {};
    }

    setFreetextByKey: (key: string, value: string) => void = (key, value) => {
        this.freetext[key] = {
            value,
        };
    };

    getFreetextValueByKey: (key: string, options?: { noFallbackToKey?: boolean }) => string = (key, options) => {
        const noFallbackToKey = options?.noFallbackToKey ?? false;
        return sanitizeHtml(this.freetext[key]?.value) || (noFallbackToKey ? '' : key);
    };
}
